<template>
  <div>
    <v-overlay z-index="2" :value="edit"></v-overlay>
    <v-container
      style="padding-top: 0px"
      :class="$vuetify.breakpoint.xlOnly ? 'container-mypad' : ''"
    >
      <v-row>
        <v-col cols="12" style="padding:8px 8px 0px 8px">
          <v-row>
            <v-col cols="8" xs="12">
              <Navigation
                :type="'tags'"
                :myOwn="myOwn"
                :username="user.username"
                :avatar="user.avatar"
              />
            </v-col>
            <v-col cols="4" xs="12">
              <div class="float-right">
                <v-btn v-if="myOwn" @click="addTagDialog = true" icon class="my-0">
                  <v-icon size="18" color="#808F9C">add_circle_outline</v-icon>
                </v-btn>
                <v-btn v-if="myOwn" @click="editMethod" icon class="my-0" style="z-index:3">
                  <v-icon size="18" color="#808F9C">edit</v-icon>
                </v-btn>
                <v-btn icon class="my-0">
                  <v-icon size="18" color="#808F9C">filter_list</v-icon>
                </v-btn>
              </div>
            </v-col>
          </v-row>
        </v-col>
      </v-row>

      <v-row>
        <v-col lg="12" style="padding:8px">
          <v-card flat :loading="loading">
            <v-data-table
              :search="search"
              :headers="headers"
              :items="records"
              item-key="Name"
              class="elevation-1"
            >
              <template v-slot:top>
                <v-toolbar class="pt-2 px-4" flat color="#2d3540">
                  <v-text-field
                    v-model="search"
                    append-icon="search"
                    label="Search"
                    single-line
                    color="#4dbac0"
                    hide-details
                  ></v-text-field>
                  <v-spacer></v-spacer>
                </v-toolbar>
              </template>

              <template v-slot:item.equity="{ item }">
                <div class="pa-2">
                  <v-sparkline
                    height="80px"
                    :value="item.equity"
                    :color="item.pl > 0 ? '#79C04D': (item.pl < 0 ?'#E62163' : '#808F9C')"
                    line-width="3"
                    smooth="10"
                    padding="0"
                  ></v-sparkline>
                </div>
              </template>

              <template v-slot:item.equityAfter="{ item }">
                <div class="pa-2">
                  <v-sparkline
                    height="80px"
                    :value="item.equityAfter"
                    :color="item.plAfter > 0 ? '#79C04D': (item.plAfter < 0 ?'#E62163' : '#808F9C')"
                    line-width="3"
                    smooth="10"
                    padding="0"
                  ></v-sparkline>
                </div>
              </template>

              <template v-slot:item.name="{ item }">
                <div>
                  <v-chip
                    style="z-index:3 !important"
                    class="float-left"
                    :close="edit"
                    @click:close="deleteStrategyMethod(item)"
                    :disabled="!item.active"
                    :color="item._owner ? '#4dbac0' : '#4dbac0'"
                  >{{item.name}}</v-chip>

                  <div v-if="item._owner" class="float-left ml-2 avatar">
                    <Avatar
                      v-if="item._owner.avatar != null"
                      :src="'http://tradeinpool.com/upload/'+item._owner.avatar+'.png'"
                      :size="34"
                    ></Avatar>
                    <Avatar v-else :username="item._owner.username" :size="34"></Avatar>
                  </div>
                </div>
              </template>
              <template v-slot:item.createdAt="{ item }">{{item.createdAt | timator(timezone)}}</template>
              <template v-slot:item.pl="{ item }">
                <v-btn
                  v-if="item._trades.length > 0"
                  x-small
                  :color="item.pl > 0 ? '#79C04D': (item.pl < 0 ?'#E62163' : '#808F9C')"
                >${{item.pl.toFixed(2)}}</v-btn>
                <span v-else>N/A</span>
              </template>
              <template v-slot:item._trades="{ item }">
                <span>{{item._trades.length}}</span>
              </template>
              <template v-slot:item._followers="{ item }">
                <v-btn
                  @click="routerMethod(item._id)"
                  text
                  icon
                  color="white"
                >{{item._followers.length}}</v-btn>
              </template>
              <template v-slot:item.action="{ item }">
                <div>
                  <v-btn @click="routerMethod(item._id)" text icon color="white">
                    <v-icon>keyboard_arrow_right</v-icon>
                  </v-btn>
                </div>
              </template>
            </v-data-table>
          </v-card>
        </v-col>
      </v-row>
    </v-container>

    <v-dialog v-model="deleteStrategyDialog" max-width="500px">
      <v-card :loading="deleteStrategyLoading">
        <v-card-title>
          <span class>
            Delete tag
            <span class="text-green">{{deleteStrategyName}}</span> ?
          </span>
        </v-card-title>

        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="blue darken-1" text @click="deleteStrategyDialog = false">No</v-btn>
          <v-btn color="blue darken-1" text @click="deleteStrategyConfirm">Yes</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <v-dialog max-width="500px" v-model="addTagDialog" transition="dialog-bottom-transition">
      <v-card :loading="dialogLoading" ref="form">
        <v-card-title>
          <span class="headline">Create New Tag</span>
        </v-card-title>
        <v-card-text>
          <v-container>
            <v-row>
              <v-col cols="12" sm="12" md="12">
                <v-text-field
                  color="#4dbac0"
                  label="Name"
                  v-model="name"
                  :error-messages="errName"
                  ref="name"
                  :rules="[() => !!name || 'This field is required']"
                  counter
                  maxlength="20"
                  required
                ></v-text-field>
                <div class="errors">
                  <li v-for="(error, index) in errors" :key="index">{{error}}</li>
                </div>
              </v-col>
              <v-col cols="12" sm="12" md="12">
                <v-textarea
                  v-model="description"
                  label="Tag description"
                  counter
                  ref="description"
                  maxlength="1024"
                  color="#4dbac0"
                ></v-textarea>
              </v-col>
            </v-row>
          </v-container>
        </v-card-text>
        <v-card-actions>
          <v-btn @click="close" text>Cancel</v-btn>
          <v-spacer></v-spacer>
          <v-slide-x-reverse-transition>
            <v-tooltip v-if="formHasErrors" left>
              <template v-slot:activator="{ on }">
                <v-btn icon class="my-0" @click="resetForm" v-on="on">
                  <v-icon color="primary">mdi-refresh</v-icon>
                </v-btn>
              </template>
              <span>Refresh form</span>
            </v-tooltip>
          </v-slide-x-reverse-transition>
          <v-btn color="primary" text @click="submit">SAVE</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <v-container
      style="padding-top: 0px"
      :class="$vuetify.breakpoint.xlOnly ? 'container-mypad' : ''"
    >
      <v-expansion-panels flat style="padding:0">
        <v-expansion-panel>
          <v-expansion-panel-header>
            <div>
              <v-icon class="mr-2">play_circle_outline</v-icon>Watch tutorials
            </div>
          </v-expansion-panel-header>
          <v-expansion-panel-content>
            <v-row>
              <v-col cols="12" style="padding:8px 8px 8px 8px" class="text-center">
                <vimeo-player video-id="416279649" />
                <vimeo-player video-id="416328240" />
              </v-col>
            </v-row>
          </v-expansion-panel-content>
        </v-expansion-panel>
      </v-expansion-panels>
    </v-container>
  </div>
</template>

<script>
var moment = require("moment-timezone");
import axios from "axios";
import { mapGetters } from "vuex";
import Navigation from "@/components/navigation.vue";
export default {
  name: "StrategyUser",

  components: { Navigation },
  data() {
    return {
      myOwn: false,
      addTagDialog: false,
      errName: [],
      edit: false,
      countdownEdit: null,
      deleteStrategyDialog: false,
      deleteStrategyLoading: false,
      deleteStrategyName: null,
      deleteStrategyID: null,
      deleteStrategyIndex: null,

      errors: null,
      dialogLoading: false,
      name: null,
      description: null,
      dialog: false,
      search: "",
      loading: false,
      headers: [
        {
          text: "Name",
          align: "left",
          sortable: true,
          value: "name"
        },
        {
          text: "Created",
          value: "createdAt",
          sortable: true,
          align: "center"
        },
        { text: "PL", value: "pl", align: "center" },
        { text: "Trades", value: "_trades", align: "center" },
        { text: "Equity", value: "equity", align: "center" },
        { text: "EquityAfter", value: "equityAfter", align: "center" },
        { text: "", value: "action", sortable: false, align: "right" }
      ],
      editItem: {
        name: "",
        description: ""
      },
      formHasErrors: false,
      errorMessages: ""
    };
  },
  watch: {
    dialog(val) {
      val || this.close();
    }
  },

  asyncComputed: {
    Tags: {
      get() {
        return new Promise((resolve, reject) => {
          axios
            .post("https://tradeinpool.com:3001/api/request/tags/", {
              method: "list",
              user: this.$route.params.name
            })
            .then(response => {
              // setTimeout(() => {
              this.loaded = true;
              resolve(response.data);
              // },1000)
            })
            .catch(err => {
              reject(err);
            });
        });
      },
      default: []
    },

    user: {
      get() {
        //if (this.username != this.$route.params.name) {
        return new Promise((resolve, reject) => {
          axios
            .post("https://tradeinpool.com:3001/api/request/user/", {
              method: "basic",
              name: this.$route.params.name
            })
            .then(response => {
              resolve(response.data);
            })
            .catch(err => {
              reject(err);
            });
        });
        //}
      },
      default: { username: "user", avatar: null }
    }
  },

  computed: {
    ...mapGetters(["username", "timezone"]),
    form() {
      return {
        name: this.name,
        description: this.description
      };
    },
    records() {
      var data = this.Tags;
      this.Tags.forEach((tag, index) => {
        data[index].equity = [0];
        data[index].pl = 0;
        data[index].equityAfter = [0];
        data[index].plAfter = 0;
        var sum = 0;
        var sumAfter = 0;
        tag._trades.forEach(piel => {
          sum += piel.ClosedProfitLoss;
          data[index].equity.push(sum);
          data[index].pl = sum;
        });
        tag._tradesAfter.forEach(piel => {
          sumAfter += piel.ClosedProfitLoss;
          data[index].equityAfter.push(sumAfter);
          data[index].plAfter = sumAfter;
        });
      });

      return data;
    }
  },
  methods: {
    routerMethod(id) {
      if (!this.edit) {
        return this.$router.push({
          name: "tags",
          params: { name: this.$route.params.name, id: id }
        });
      }
    },
    resetForm() {
      this.errorMessages = [];
      this.formHasErrors = false;

      Object.keys(this.form).forEach(f => {
        this.$refs[f].reset();
      });
    },
    close() {
      this.addTagDialog = false;
      this.errName = [];
      this.formHasErrors = false;
      this.name = null;
      this.description = null;
      clearTimeout(this.countdownEdit);
      this.countdownEdit = setTimeout(() => {
        this.edit = false;
      }, 8000);
    },
    submit() {
      //this.dialog = false,
      this.formHasErrors = false;
      if (!this.form["name"]) this.formHasErrors = true;
      this.$refs["name"].validate(true);

      if (this.formHasErrors == false) {
        this.dialogLoading = true;
        axios
          .post("https://tradeinpool.com:3001/api/add/tags/", {
            data: this.form
          })
          .then(response => {
            this.Tags.unshift(response.data);
            this.close();
            this.dialogLoading = false;
          })
          .catch(err => {
            this.errName = err.response.data.message;
            this.dialogLoading = false;
          });
      }
    },
    editMethod() {
      if (this.edit) {
        clearTimeout(this.countdownEdit);
        this.edit = false;
      } else {
        this.edit = true;
        this.countdownEdit = setTimeout(() => {
          this.edit = false;
        }, 8000);
      }
    },
    deleteStrategyMethod(strategy, index) {
      clearTimeout(this.countdownEdit);
      this.deleteStrategyName = strategy.name;
      this.deleteStrategyID = strategy._id;
      this.deleteStrategyIndex = index;
      this.deleteStrategyDialog = true;
    },
    deleteStrategyConfirm() {
      this.deleteStrategyLoading = true;
      axios
        .post("https://tradeinpool.com:3001/api/remove/tags/", {
          method: "soft",
          id: this.deleteStrategyID
        })
        .then(response => {
          clearTimeout(this.countdownEdit);
          this.countdownEdit = setTimeout(() => {
            this.edit = false;
          }, 8000);
          if (response.data) {
            this.Tags.forEach((tag, index) => {
              if (tag._id == response.data._id) {
                this.Tags.splice(index, 1);
              }
            });
          }
          this.deleteStrategyDialog = false;
          this.deleteStrategyLoading = false;
        })
        .catch(err => {
          alert(err);
          this.deleteStrategyLoading = false;
        });
    }
  },
  filters: {
    timator: function(value, timezone) {
      var millis = value;
      //var newTime = moment.tz(millis, timezone).format("YYYY-MM-DD HH:mm");
      var newTime = moment.tz(millis, timezone).fromNow();
      return newTime;
    }
  },
  created() {
    if (this.username == this.$route.params.name) {
      this.myOwn = true;
    }
  }
};
</script>

<style scoped>
.list-enter-active,
.list-leave-active,
.list-move {
  transition: 500ms cubic-bezier(0.59, 0.12, 0.34, 0.95);
  transition-property: opacity, transform;
}

.list-enter {
  opacity: 0;
  transform: translateX(50px) scaleY(0.5);
}

.list-enter-to {
  opacity: 1;
  transform: translateX(0) scaleY(1);
}

.list-leave-active {
  position: absolute;
}

.list-leave-to {
  opacity: 0;
  transform: scaleY(0);
  transform-origin: center top;
}

.myChip {
  float: left;
  background: #4dbac0 !important;
  width: auto;
  height: 34px;
  border-radius: 17px;
}

.avatar {
  cursor: pointer;
  transition: 0.3s;
}
.avatar:hover {
  opacity: 0.8;
}
</style>